import { Box, Drawer, IconButton } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DrawerContent from "./DrawerContent";
import { useStoreContext } from "..";

interface Props {
  open: boolean;
  onClose: () => void;
}

const MobileDrawer = ({ open, onClose }: Props) => {
  const { routerStore, keycloakStore } = useStoreContext();
  return (
    <Drawer
      variant="permanent"
      anchor="bottom"
      open={open}
      onClose={onClose}
      sx={{
        zIndex: 5,
        height: "100%",
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          height: "100%",
          boxSizing: "border-box",
        },
      }}
    >
      <Box sx={{ overflow: "auto" }}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{ alignSelf: "flex-end", marginRight: 1 }}
          >
            <CloseOutlinedIcon fontSize="large" />
          </IconButton>
        </Box>
        <DrawerContent
          onLinkClick={(url: string) => {
            onClose();
            routerStore.history.push(url);
          }}
          onLogout={() => {
            onClose();
            keycloakStore.logout();
          }}
        />
      </Box>
    </Drawer>
  );
};

export default MobileDrawer;
